import { CommonFunctions } from "../static/common-functions";
import { BaseBus } from "./BaseBus";

export class BidEquipmentTabBus extends BaseBus {
    constructor(busObj: BidEquipmentTabBus) {
        // if (!CommonFunctions.hasGuidValue(busObj.bidRefrigerantEquipmentsId)) {
        //     busObj.bidRefrigerantEquipmentsId = '00000000-0000-0000-0000-000000000000';
        //     busObj.insertUserId = '00000000-0000-0000-0000-000000000000';
        //     busObj.updateUserId = '00000000-0000-0000-0000-000000000000';
        //     busObj.sortOrder = 1;
        // }
        super(busObj);

    }
    CID(): any {
        return this.refrigerantEquipmentsId;
    }
    bidSheetDetailId: string;
    qty: number;
    description: string;
    material: number;
    labor: number;
    refrigerant: number;
    insertDt: Date;
    insertUserId: string;
    updateDt: Date;
    updateUserId: string;
    refrigerantEquipmentsId: string;
    isActive: boolean;
    sortOrder: any;
}